import React from "react";

const EduSpinner = ({ label = "Loading..." }) => (
  <div className="edu-spinner-wrap">
    <svg className="edu-spinner-svg" viewBox="0 0 64 64" fill="none">
      {/* Book */}
      <rect x="8" y="24" width="48" height="28" rx="6" fill="#e3f2fd" stroke="#1976d2" strokeWidth="2"/>
      <rect x="16" y="32" width="32" height="14" rx="3" fill="#bbdefb" />
      {/* Pages */}
      <rect x="22" y="36" width="8" height="6" rx="1" fill="#fff"/>
      <rect x="34" y="36" width="8" height="6" rx="1" fill="#fff"/>
      {/* Graduation cap */}
      <polygon points="32,10 54,18 32,26 10,18" fill="#1976d2"/>
      <rect x="30" y="26" width="4" height="10" rx="2" fill="#1976d2"/>
      {/* Tassel */}
      <line x1="32" y1="36" x2="32" y2="44" stroke="#ffd600" strokeWidth="2" />
      <circle cx="32" cy="44" r="2" fill="#ffd600" />
    </svg>
    <div className="edu-spinner-text">
      {label}
    </div>
  </div>
);

export default EduSpinner;